import React, { useEffect, useRef } from 'react';
import { Route, Routes } from "react-router-dom";

import { useState } from 'react';
import './ComponentsCss/Profile.css';
import axios from 'axios';

import useAuth from '../hooks/useAuth.js';
import toast, { Toaster } from 'react-hot-toast';
import PersistLogin from './PersistLogin';
import UserInfo from './UserInfo.js';
// loading 
import BarLoader from "react-spinners/BarLoader";



const notify = (Text) => toast.success(Text);
const errNotify = (Text) => toast.error(Text);
const LOGIN_URL = 'userauth/login';
const Profile = () => {

  const [CreateProfileBool, SetCreateProfileBool] = useState(false);
  const [UserId, SetUserId] = useState("");
  const [UserPw, SetUserPw] = useState("");
  const [ConfirmUserPw, SetConfirmUserPw] = useState("");
  const [UserName, SetUserName] = useState("");
  const [UserBD, SetUserBD] = useState("");

  const [UserEmail, SetUserEmail] = useState("");
  const [UserMobile, SetUserMobile] = useState("");

  const [token_version_id, set_token_version_id] = useState("");
  const [enc_data, set_enc_data] = useState("");
  const [integrity, set_integrity] = useState("");
  const [key, set_key] = useState("");
  const [iv, set_iv] = useState("");
  const [hmac_key, set_hmac_key] = useState("");
  const [req_no, set_req_no] = useState("");

  // login page 
  const [LoginSuccess, SetLoginSuccess] = useState(false);
  const { setAuth, auth, persist, setPersist } = useAuth();

  // show form 
  const [UserDetailSuccess, SetUserDetailSuccess] = useState(false);
  // loader circle 
  let [LoadingCir, SetLoadingCir] = useState("#253b60");
  const [LoadingCirBool, SetLoadingCirBool] = useState(false);


  const togglePersist = () => {
    setPersist(prev => !prev);
  }
  useEffect(() => {
    localStorage.setItem("persist", persist);
  }, [persist])

  useEffect(() => {
    SetUserId("");
    SetUserPw("");
    SetConfirmUserPw("");
    SetUserName("");
    SetUserBD("");

    SetUserEmail("");
    SetUserMobile("");
    //SetUserDetailSuccess(false);
    if (CreateProfileBool == true) {
      axiosNiceApiInit();
    }
  }, [CreateProfileBool]);


  function SetNiceApiDetails(data) {
    set_token_version_id(data?.token_version_id);
    set_enc_data(data?.enc_data);
    set_integrity(data?.integrity);
    set_key(data?.key);
    set_iv(data?.iv);
    set_hmac_key(data?.hmac_key);
    set_req_no(data?.req_no);


  }
  function SetUserDetails(data) {
    // user details 
    SetUserName(data?.name);
    SetUserBD(data?.birthdate);
    SetUserMobile(data?.mobileno);
  }

  const openInNewTab = (url) => {
    restartStatusCheck();
    const windowName = '_blank'; // or a specific name
    const windowFeatures = 'height=600,width=800,left=200,top=100';

    window.open(url, windowName, windowFeatures);
  };


  const axiosStatusCheckTimer = useRef();
  useEffect(() => {
    return () => CloseCleanUp();
  }, []);

  function CloseCleanUp() {
    clearInterval(axiosStatusCheckTimer.current);
  }
  function restartStatusCheck() {
    stopAxiosStatusCheck();
    startAxiosStatusCheck();
  }
  const startAxiosStatusCheck = () => {
    //console.log(" startAxiosStatusCheck()");
    axiosStatusCheckTimer.current = setInterval(() => {
      axiosNiceGetSession();

    }, 2000);
  };
  const stopAxiosStatusCheck = () => {
    console.log(" stopAxiosStatusCheck()");
    clearInterval(axiosStatusCheckTimer.current);
  };
  // axios 
  // test axios 
  // http://localhost/userauth/allUsers 
  const axiosNiceApiInit = async () => {

    console.log(" GET AXIOS TEST ");
    try {
      const response = await axios.get("http://15.165.205.88:8888/checkplus_main_custom"
      );
      if (response) {
        console.log(JSON.stringify(response.data, null, 2));
        SetNiceApiDetails(response.data);

      }

    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Missing Username or Password');
      } else if (err.response?.status === 401) {
        console.log('--Unauthorized');
      } else {
        console.log('ERR');
      }

    }
  }

  const axiosNiceGetSession = async () => {

    console.log(" axiosNiceGetSession");
    try {
      const response = await axios.get("http://15.165.205.88:8888/getsession"
      );
      if (response) {
        console.log(response.data);
        const data = JSON.parse(response.data);

        if (data && data.responseno != "" && data.name != "" && data.birthdate != "" && data.gender != "") {
          SetUserDetails(data);
          stopAxiosStatusCheck();
          SetUserDetailSuccess(true);
          SetLoadingCirBool(false);
          axsioDeleteSession();
        } else {
          SetUserDetailSuccess(false);
          SetLoadingCirBool(true);
        }

        //var dataJson = JSON.parse(response?.data).data;
        //console.log(dataJson);
        //console.log(dataJson.name);
        //
      } else {
        SetUserDetailSuccess(false);
        SetLoadingCirBool(true);
      }

    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Missing Username or Password');
      } else if (err.response?.status === 401) {
        console.log('--Unauthorized');
      } else {
        console.log('ERR');
      }

    }
  }

  const axsioDeleteSession = async () => {

    console.log("axsioDeleteSession ");
    try {
      const response = await axios.get("http://15.165.205.88:8888/deleteSession"
      );


    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Missing Username or Password');
      } else if (err.response?.status === 401) {
        console.log('--Unauthorized');
      } else {
        console.log('ERR');
      }

    }
  }
  const axiosTest = async () => {

    console.log(" GET AXIOS TEST ");
    try {
      const response = await axios.get("http://15.165.205.88:8888/deleteSession"
      );


    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Missing Username or Password');
      } else if (err.response?.status === 401) {
        console.log('--Unauthorized');
      } else {
        console.log('ERR');
      }

    }
  }

  function checkRegister() {
    if (
      UserName == "" || UserBD == ""
    ) {
      errNotify("본인인증을 진행해주세요.");
    } else if (UserEmail == "") {
      errNotify("이메일을 입력해주세요.");
    } else {
      axiosRegister();
    }

  }
  const axiosRegister = async () => {
    console.log(" Registering user ");
    try {
      // const { userId, userPw, confUserPw, userName, 
      //        userEmail, userMobile, userRole } = req.body;
      var registerDataJson = "";
      registerDataJson = JSON.stringify({
        userId: UserId,
        userPw: UserPw,
        confUserPw: ConfirmUserPw,
        userName: UserName,
        userBirthDate: UserBD,
        userEmail: UserEmail,
        userMobile: UserMobile,
        userRole: 2
      }, null, 2);

      console.log("AXIOS Registering user  : " + registerDataJson);
      var finalIP = "";
      // 	"/emergency/rssi/module-status-set/<ip>"
      finalIP = "https://15.165.205.88/api/register";
      //console.log(" axiosPostModuleStatus" + finalIP);
      const response = await axios.post(finalIP,
        registerDataJson,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,

        }
      );
      if (response) {
        console.log(" register success !");
        SetUserId("");
        SetUserPw("");
        SetCreateProfileBool(!CreateProfileBool);
      }
    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Username and password are required.');
        errNotify("ID 와 비밀번호를 입력 해주세요.");
      } else if (err.response?.status === 401) {
        console.log('-- Wrong conf password ');
        errNotify("비밀번호 확인에 같은 비밀번호를 입력해주세요. ");
      }
      else if (err.response?.status === 402) {
        console.log('-- Username already exists ');
        errNotify("이미 존재하는 ID 입니다. 다른 ID를 사용해주세요.");
      } else {
        console.log('ERR');
      }

    }
  }
  const axiosLogin = async () => {
    console.log(" Logging in user ");
    try {
      var loginDataJson = "";
      loginDataJson = JSON.stringify({
        userId: UserId,
        userPw: UserPw
      }, null, 2);

      console.log("AXIOS Logging user  : " + loginDataJson);
      var finalIP = "";

      finalIP = "https://stepupkorea.kr/api/auth";

      const response = await axios.post(finalIP,
        loginDataJson,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
          credentials: 'include'
        }
      );
      if (response) {
        console.log(" Login success !");
        const accessToken = response?.data?.accessToken;
        const roles = response?.data?.roles;
        console.log("Login.sj ::: ", JSON.stringify(response?.data));
        setAuth({ UserId, UserPw, roles, accessToken });
        console.log("Login.sj ::: ", JSON.stringify({ UserId, UserPw, roles, accessToken }));
        SetUserId("");
        SetUserPw("");
        SetLoginSuccess(true);
      }



    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 404) {
        console.log('--No user ID');
      } else if (err.response?.status === 400) {
        console.log('Wrong pass ');
        errNotify("ID가 이미 존재합니다. 다른 아이디를 사용해주세요.");
      } else {
        console.log('ERR');
      }

    }
  }

  function fnPopup() {
    restartStatusCheck();
    window.open('', 'popupChk', 'width=480, height=812, top=100, fullscreen=no, menubar=no, status=no, toolbar=no,titlebar=yes, location=no, scrollbar=no');
    document.form_chk.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
    document.form_chk.target = "popupChk";
    document.form_chk.submit();

  }
  /* 


  */
  return (
    <>
      <div style={{ height: "150px" }}>
      </div>
      <div className="login-container">

        <div className="login-box" >

          {
            CreateProfileBool == true ?

              <>
                {
                  // create accoutn view
                }
                <div className="input-group" >
                  <form name="form_chk" method="post">
                    <input type="hidden" name="m" value="service" />
                    <input type="hidden" name="token_version_id" value={token_version_id} />
                    <input type="hidden" name="enc_data" value={enc_data} />
                    <input type="hidden" name="integrity_value" value={integrity} />
                    {
                      //<!--<a href="javascript:fnPopup();"> CheckPlus 안심본인인증 Click</a> -->


                    }


                  </form>
                </div>
                {
                  UserDetailSuccess == true ?
                    <>
                      <div className="input-group" >
                        <label>ID</label>
                        <input type="text" id="id"
                          value={UserId} required onInput={e => SetUserId(e.target.value)} />
                      </div>
                      <div className="input-group">
                        <label>비밀번호</label>
                        <input type="password" id="password" name="password" value={UserPw} required onInput={e => SetUserPw(e.target.value)} />
                      </div>
                      <div className="input-group">
                        <label>비밀번호 확인</label>
                        <input type="password" id="password" name="password" value={ConfirmUserPw} required onInput={e => SetConfirmUserPw(e.target.value)} />
                      </div>


                      <div className="input-group" >
                        <label>이름</label>
                        <input type="text" disabled={true} value={UserName} required />
                      </div>
                      <div className="input-group" >
                        <label>생년월일</label>
                        <input type="text" disabled={true} value={UserBD} required />
                      </div>
                      <div className="input-group" >
                        <label>휴대폰 번호</label>
                        <input type="text" disabled={true} value={UserMobile} required />
                      </div>
                      <div className="input-group">
                        <label>이메일</label>
                        <input type="email" id="email" name="email" value={UserEmail} required onInput={e => SetUserEmail(e.target.value)} />
                      </div>



                      <button className="login-button" onClick={() => checkRegister()}>회원가입</button>
                    </>
                    :
                    <>

                      {
                        LoadingCirBool ? <button class="mobile-button " style={{ marginTop: "100px" }}>
                          로딩중...
                        </button> :
                          <button class="mobile-button " style={{ marginTop: "100px" }} onClick={() => fnPopup()}>
                            안심본인인증 하러가기
                          </button>
                      }



                    </>
                }


                <div className="create-account">
                  <p>이미 회원이신가요? <a style={{ cursor: "pointer" }} onClick={() => SetCreateProfileBool(!CreateProfileBool)}> 로그인 하기</a></p>
                </div>
              </>
              :
              <>
                {
                  // login view 
                  auth?.accessToken ?
                    <>
                      <Routes>
                        <Route element={<PersistLogin />}>
                          <Route path="/" element={<UserInfo />} />
                        </Route>
                      </Routes>


                    </>
                    :
                    <>
                      <div className="input-group">
                        <label>ID</label>
                        <input type="text" id="id"
                          value={UserId} required onInput={e => SetUserId(e.target.value)} />
                      </div>
                      <div className="input-group">
                        <label>비밀번호</label>
                        <input type="password" id="password" name="password" value={UserPw} required onInput={e => SetUserPw(e.target.value)} />
                      </div>
                      <button className="login-button" onClick={() => axiosLogin()}>로그인</button>

                      {
                        /*
                         <div className="remainLogIn" >
    
                          <input
                            className="remainLoginCheckBox"
                            type="checkbox"
                            id="persist"
                            onChange={togglePersist}
                            checked={persist}
                          />
                          <label htmlFor="persist">자동 로그인</label>
                        </div>
                        */
                      }

                      <div className="create-account">
                        <p>회원이 아니신가요? <a style={{ cursor: "pointer" }} onClick={() => SetCreateProfileBool(!CreateProfileBool)}> 계정 만들기</a></p>
                      </div>
                    </>
                }

              </>
          }

        </div>
      </div>
    </>
  )
}

export default Profile